import { exists } from '@/api'

export interface LendCount {
  code: string
  name: string
  count: number
}

export function LendCountFromJSON(json: any): LendCount {
  return LendCountFromJSONTyped(json)
}

export function LendCountFromJSONTyped(json: any): LendCount {
  if (json === undefined || json === null) {
    return json
  }
  return {
    code: exists(json, 'code') ? json.code : '',
    name: exists(json, 'name') ? json.name : '',
    count: exists(json, 'count') ? json.count : 0
  }
}
